import React from 'react';
import styles from './styles.less';
import { LocalizationContext } from '../../hoc/Localization';

const Noschedule = () => {
  const { t } = React.useContext(LocalizationContext);

  return (
    <div>
      <div className={styles.noschedule}>
        <img src="/static/images/noSchedule.svg" alt="noSchedule" />
        <div>
          <p>{t('course.noschedule.warning')}</p>
        </div>
      </div>
    </div>
  );
};

export default Noschedule;
